<template>
  <div class="preloader" v-if="isLoading">
    <span class="preloader__spinner far fa-spinner fa-spin" />
  </div>

  <div v-else-if="isAccessGranted" class="h-100">
    <b-tabs class="vis-admin-panel">
      <b-tab lazy :title="$t('adminPanel.Users')">
        <vis-user-grid-view :eventBus="userEventBus" />
      </b-tab>
      <b-tab lazy :title="$t('adminPanel.Groups')">
        <vis-group-grid-view :eventBus="groupEventBus" />
      </b-tab>
      <b-tab lazy :title="$t('adminPanel.CacheManagement')">
        <vis-cache-grid-view />
      </b-tab>
    </b-tabs>
  </div>

  <div v-else>{{ $t("accessDenied")}}</div>
</template>

<script>
import api from "@/api/visary-api"
import VisUserGridView from "./vis-user-grid-view";
import VisGroupGridView from "./vis-group-grid-view";
import VisCacheGridView from "./vis-cache-grid-view";
import Vue from "vue";

export default {
  name: "vis-admin-panel",
  components: {
    VisUserGridView,
    VisGroupGridView,
    VisCacheGridView
  },
  data() {
    return {
      userEventBus: new Vue(),
      groupEventBus: new Vue(),
      isAccessGranted: false,
      isLoading: false,
    };
  },

  created() {
    this.checkAccess()
  },

  destroyed() {
    if(this.userEventBus)
      this.userEventBus.$destroy();
    if(this.groupEventBus)
      this.groupEventBus.$destroy();
  },

  methods: {
    async checkAccess() {
      this.isLoading = true

      this.isAccessGranted = await api.user.checkPathAccess({ path: this.$route.path })

      this.isLoading = false
    },
  },
};
</script>
